

<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};


if (process.env.VUE_APP_FIREBASE_AUTH_ENV == "production") {
  document.title = "Edusign";
}
if (process.env.VUE_APP_FIREBASE_AUTH_ENV == "staging") {
  document.title = "Edusign-Staging";
}

</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
